module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "box-401"
  }, [_c('h1', [_vm._v("您没有浏览这个页面的权限")]), _vm._v(" "), _c('ul', [_c('li', [_c('Button', {
    attrs: {
      "size": "large",
      "type": "text"
    },
    on: {
      "click": _vm.backHome
    }
  }, [_vm._v("返回首页")]), _vm._v(" "), _c('Button', {
    attrs: {
      "size": "large",
      "type": "text"
    }
  }, [_vm._v("返回上一页(" + _vm._s(_vm.second) + "s)")])], 1)])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-52922774","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Error401.vue
// module id = 690
// module chunks = 1